import { Grouping } from "@devexpress/dx-react-grid";
import { DiscrepancyListState, UpdateDiscrepancyListActionPayload } from "./rootReducerTypes";
import {
    UPDATE_DISCREPANCY_TYPE, UPDATE_DISCREPANCIES, REQUEST_ERROR, FETCH_INIT, SET_CURRENT_PAGE, UPDATE_QUERY, SetPageSizeAction, SET_PAGE_SIZE, UPDATE_DISCREPANCY_STATUS, UPDATE_DISCREPANCY_ISREQUESTCLOSEDCHECKED, UpdateSortByAction, UPDATE_SORTBY, UPDATE_SEARCH_DISCREPANCIES, UpdateSearcDiscrepanciesAction, ChangeGroupingAction, CHANGE_GROUPING, SetExpandedGroupsAction, SET_EXPANDED_GROUPS, SET_SELECTED_DISCREPANCY_ROWS,
    UpdateDiscrepanciesAction
    , RequestErrorAction
    , FetchInitAction
    , SetCurrentPageAction
    , UpdateQueryAction
    , UpdatedDiscrepancyStatusAction
    , UpdatedDiscrepancyIsRequestedCloseCheckedAction
    ,DiscrepancyListActionTypes
    ,END_LOADING
    ,EndLoadingAction
    ,UpdateDiscrepancyTypeAction
    ,UpdateDiscrepancySelectedRowsAction
} from './discrepancyListActionsAndReducerTypes';
import { Discrepancy } from "../Interfaces";

// #region actions
export function updateDiscrepancies(updateDiscrepanciesActionPayload: UpdateDiscrepancyListActionPayload): UpdateDiscrepanciesAction {
    return {
        type: UPDATE_DISCREPANCIES,
        updateDiscrepanciesActionPayload: updateDiscrepanciesActionPayload,
    };
}

export function requestError(): RequestErrorAction {
    return {
        type: REQUEST_ERROR,
    };
}
export function fetchInit(): FetchInitAction {
    return {
        type: FETCH_INIT,
    };
}

export function endLoading(): EndLoadingAction {
    return {
        type: END_LOADING,
    };
}
export function setCurrentPage(currentPage: number): SetCurrentPageAction {
    return {
        type: SET_CURRENT_PAGE,
        currentPage
    };
}
export function setPageSize(pageSize: number): SetPageSizeAction {
    return {
        type: SET_PAGE_SIZE,
        pageSize
    };
}
export function updateQuery(lastQuery: string): UpdateQueryAction {
    return {
        type: UPDATE_QUERY,
        lastQuery
    };
}

export function updateIsRequestedClosedChecked(checked: boolean): UpdatedDiscrepancyIsRequestedCloseCheckedAction {
    return {
        type: UPDATE_DISCREPANCY_ISREQUESTCLOSEDCHECKED,
        isRequestedClosedChecked: checked
    };
}

export function updateDiscrepancyStatus(discrepancyStatus: any): UpdatedDiscrepancyStatusAction {
    return {
        type: UPDATE_DISCREPANCY_STATUS,
        discrepancyStatus: discrepancyStatus
    };
}

export function updateDiscrepancyType(discrepancyType: any): UpdateDiscrepancyTypeAction {
    return {
        type: UPDATE_DISCREPANCY_TYPE,
        discrepancyType: discrepancyType
    };
}

export function updateSortBy(payload: string): UpdateSortByAction {
    return {
        type: UPDATE_SORTBY,
        sortBy: payload
    };
}

export function updateSearchDiscrepancies(payload: string): UpdateSearcDiscrepanciesAction {
    return {
        type: UPDATE_SEARCH_DISCREPANCIES,
        searchText: payload
    };
}

export function changeGrouping(payload: Grouping[]): ChangeGroupingAction {
    return {
        type: CHANGE_GROUPING,
        grouping: payload
    };
}

export function setExpandedGroups(payload: string[]): SetExpandedGroupsAction {
    return {
        type: SET_EXPANDED_GROUPS,
        expandedGroups: payload
    };
}

export function setSelectedRows(payload: Array<Discrepancy>): UpdateDiscrepancySelectedRowsAction {
    return {
        type: SET_SELECTED_DISCREPANCY_ROWS,
        selectedRows: payload
    };
}

// #end region actions

export default function discrepanyListReducer(state: DiscrepancyListState = initialState, action: DiscrepancyListActionTypes): DiscrepancyListState {
    switch (action.type) {
        case 'UPDATE_DISCREPANCIES':
            return {
                ...state,
                discrepancies: action.updateDiscrepanciesActionPayload.discrepancies,
                totalCount: action.updateDiscrepanciesActionPayload.totalCount,
                totalGroupCount: action.updateDiscrepanciesActionPayload.totalGroupCount ? action.updateDiscrepanciesActionPayload.totalGroupCount : state.totalGroupCount,
                skip: action.updateDiscrepanciesActionPayload.skip ? action.updateDiscrepanciesActionPayload.skip : state.skip,
                groupChildrenSkip: action.updateDiscrepanciesActionPayload.groupChildrenSkip ? action.updateDiscrepanciesActionPayload.groupChildrenSkip : state.groupChildrenSkip,
                loading: false,
                tempGrouping: null,
                tempExpandedGroups: null,
            };
        case 'REQUEST_ERROR':
            return {
                ...state,
                loading: false,
            };
        case 'FETCH_INIT':
            return {
                ...state,
                loading: true,
            };
        case 'END_LOADING':
            return {
                ...state,
                loading: false,
            };
        case 'SET_CURRENT_PAGE':
            return {
                ...state,
                currentPage: action.currentPage,
                skip: action.currentPage * state.pageSize,
                groupChildrenSkip: state.expandedGroups.length > 0 ? action.currentPage * state.pageSize : 0
            };
        case 'UPDATE_QUERY':
            return {
                ...state,
                lastQuery: action.lastQuery,
            };
        case 'SET_PAGE_SIZE':
            return {
                ...state,
                pageSize: action.pageSize,
            };
        case 'UPDATE_DISCREPANCY_ISREQUESTCLOSEDCHECKED':
            return {
                ...state,
                isRequestedClosedChecked: action.isRequestedClosedChecked
            };
        case 'UPDATE_DISCREPANCY_STATUS':
            return {
                ...state,
                discrepancyStatus: action.discrepancyStatus
            };
        case 'UPDATE_DISCREPANCY_TYPE':
            return {
                ...state,
                discrepancyType: action.discrepancyType
            };
        case 'UPDATE_SORTBY':
            return {
                ...state,
                sortBy: action.sortBy,
            };
        case 'UPDATE_SEARCH_DISCREPANCIES':
            return {
                ...state,
                searchText: action.searchText,
            };
        case 'CHANGE_GROUPING':
            return {
                ...state,
                grouping: action.grouping,
                tempGrouping: state.tempGrouping === null ? state.grouping : state.tempGrouping,
                tempExpandedGroups: state.expandedGroups,
            };
        case 'SET_EXPANDED_GROUPS':
            return {
                ...state,
                expandedGroups: action.expandedGroups,
                totalCount: action.expandedGroups.length === 0 && state.grouping.length > 0 ? state.totalGroupCount : state.totalCount,
                groupChildrenSkip: 0
            };
        case 'SET_SELECTED_DISCREPANCY_ROWS':
            return {
                ...state,
                selectedRows: action.selectedRows
            };
        default:
            return state;
    }
}

export const initialState: DiscrepancyListState = {
    //Temp data remove it after the endpoint is ready!!
    discrepancies: [],
    skip: 0,
    totalCount: 0,
    totalGroupCount: 0,
    loading: false,
    lastQuery: '',
    currentPage: 0,
    pageSize: 50,
    snackBar: { isShow: false, message: '', severity: undefined },
    sortBy: '',
    searchText: '',
    grouping: [],
    expandedGroups: [],
    tempGrouping: null,
    tempExpandedGroups: null,
    groupChildrenSkip: 0,
    isRequestedClosedChecked: false,
    discrepancyStatus: null,
    discrepancyType: null,
    dateType: 1,
    selectedRows : []
};